<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="assets/techFiraLogo/assset1.png" alt="techfira-logo" style="width: 160px;">  
    </a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="control-item">
      <nb-search type="rotate-layout" style="background-color: transparent !important;"></nb-search>
    </nb-action>
    
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    
    <!-- 🔥 Yahan user ka naam aur uske theek neechay Role Title bind kiya hai -->
    <nb-action class="user-action">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user.name"
               [title]="user.roleName">
      </nb-user>
    </nb-action>
    
  </nb-actions>
</div>